module.exports = "/_next/static/images/row1-3-5009367df8201f9e71876c2835930a4d.png";